__turbopack_context__.v({
  "action": "_2YlT5q_action",
  "allTabsWrap": "_2YlT5q_allTabsWrap",
  "close": "_2YlT5q_close",
  "dirty": "_2YlT5q_dirty",
  "icon": "_2YlT5q_icon",
  "labels": "_2YlT5q_labels",
  "menu": "_2YlT5q_menu",
  "menuItem": "_2YlT5q_menuItem",
  "name": "_2YlT5q_name",
  "root": "_2YlT5q_root",
  "section": "_2YlT5q_section",
  "srOnly": "_2YlT5q_srOnly",
  "tab": "_2YlT5q_tab",
  "tabList": "_2YlT5q_tabList",
  "tabShell": "_2YlT5q_tabShell",
  "tabViewport": "_2YlT5q_tabViewport",
});
